import {VueController} from '@/service/support/vuex-controller';

export default VueController("PdfSignatureStatus", {
    props: {
        signatureInfo: {
            type: Object,
            default: null
        }
    },
    computed: {
        hasSignatures() {
            return this.signatureInfo && this.signatureInfo.hasSignatures === true;
        },
        isSupported() {
            return this.signatureInfo && this.signatureInfo.supported === true;
        },
        overallStatus() {
            if (!this.signatureInfo) return 'unknown';
            return this.signatureInfo.overallStatus || 'unknown';
        },
        statusColor() {
            switch (this.overallStatus) {
                case 'valid':
                    return 'success';
                case 'untrusted':
                    return 'warning';
                case 'invalid':
                    return 'error';
                case 'none':
                    return 'info';
                default:
                    return 'info';
            }
        },
        statusType() {
            // VAlert only accepts: success, info, warning, error
            switch (this.overallStatus) {
                case 'valid':
                    return 'success';
                case 'untrusted':
                    return 'warning';
                case 'invalid':
                    return 'error';
                case 'none':
                    return 'info';
                default:
                    return 'info';
            }
        },
        statusIcon() {
            switch (this.overallStatus) {
                case 'valid':
                    return 'mdi-check-decagram';
                case 'untrusted':
                    return 'mdi-alert';
                case 'invalid':
                    return 'mdi-close-circle';
                case 'none':
                    return 'mdi-information';
                default:
                    return 'mdi-help-circle';
            }
        },
        statusMessage() {
            if (!this.signatureInfo) {
                return 'Checking signature status...';
            }
            
            if (!this.isSupported) {
                return this.signatureInfo.message || 'Digital signature validation is not supported';
            }
            
            if (this.signatureInfo.error) {
                return this.signatureInfo.message || 'Error checking signature status';
            }
            
            switch (this.overallStatus) {
                case 'valid':
                    return 'Digitally signed and valid - Not modified since signing';
                case 'untrusted':
                    return 'Signature exists but certificate is not trusted';
                case 'invalid':
                    return 'Warning: Document may have been modified after signing';
                case 'none':
                    return 'This document has not been digitally signed';
                default:
                    return 'Signature status unknown';
            }
        },
        detailsAvailable() {
            return this.hasSignatures && this.signatureInfo.signatures && this.signatureInfo.signatures.length > 0;
        }
    },
    data() {
        return {
            showDetails: false
        };
    },
    methods: {
        toggleDetails() {
            this.showDetails = !this.showDetails;
        }
    }
});

